import { downloadBlobImage } from './downloadBlobImage'

const downloadBase64Image = (base64Url: string, filename: string) => {
  fetch(base64Url)
    .then((res) => res.blob())
    .then((blob) => downloadBlobImage(blob, filename))
    .catch((error) => console.error('Download failed:', error))
}

export { downloadBase64Image }
